/**
 * Мелочи русского языка, общие для экранов.
 *
 * Вынесены отдельно, потому что нужны и приложению, и онбордингу, а вторая
 * копия согласования числительных разойдётся с первой на первом же «22 дня».
 */

/** «1 день», «2 дня», «5 дней». Число включено в результат. */
export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  const w = m10 === 1 && m100 !== 11 ? one
    : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? few : many;
  return `${n} ${w}`;
}

/** Только слово, без числа: «дня» для «за эти 22 дня». */
export const pluralWord = (n: number, one: string, few: string, many: string): string =>
  plural(n, one, few, many).split(' ').slice(1).join(' ');

/**
 * Дата словами: «12 сентября 2026».
 *
 * «2026-09-12» человек не читает — чтобы понять, когда это было, ему
 * приходится разбирать формат. В карточке чека это особенно заметно: рядом
 * стоит время, и вместе они выглядят как строка из журнала, а не как покупка.
 */
const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

/** «17 октября» — год только если он не текущий: «9 февраля 2027». */
export function dayMonth(date: string, today: string): string {
  const full = dayMonthYear(date);
  return date.slice(0, 4) === today.slice(0, 4) ? full.replace(/ \d{4}$/, '') : full;
}

export function dayMonthYear(date: string): string {
  const [y, m, d] = date.split('-');
  const month = MONTHS[Number(m) - 1];
  if (!y || !month || !d) return date;
  return `${Number(d)} ${month} ${y}`;
}
